module.exports = __webpack_public_path__ + "img/cryptocom.19806c3a.png";